import { useCallback } from 'react'

import type { IProjectIssue } from 'types'

import TaskInfo from './TaskInfo'

interface TaskItemProps {
  number: number
  issue: IProjectIssue
  timeZone?: string
  onClick?: (taskId: number) => void
}

const TaskItem = ({ number, issue, timeZone, onClick }: TaskItemProps) => {
  const handleClick = useCallback(() => {
    onClick?.(issue.id)
  }, [issue, onClick])

  return (
    <li className="task-item" onClick={handleClick}>
      <div className="title">{issue.title}</div>
      <TaskInfo timeZone={timeZone} number={number} issue={issue} />
    </li>
  )
}

export default TaskItem
